import { TCampaniaEspecificaViewModel } from 'src/app/components/_mantenimiento/campanias/campaniasespecificas/campaniaespecifica.types';

export class NavMenuServiceCampania {
    protected _currentCampania: TCampaniaEspecificaViewModel | undefined = new TCampaniaEspecificaViewModel();

    protected refresh(): void {
        // TO BE OVERRIDEN IN THE PARENT
    }

    protected resetCampaniaData(): void {
        this._currentCampania = new TCampaniaEspecificaViewModel();
    }

    protected set currentCam(value: TCampaniaEspecificaViewModel) {
        this._currentCampania = value;
        this.refresh();
    }

    protected get currentCam(): TCampaniaEspecificaViewModel {
        if (!this._currentCampania) {
            this._currentCampania = new TCampaniaEspecificaViewModel();
        }
        return this._currentCampania;
    }

    public updateMenuServiceForCampania(id: number): void {
        const vm = new TCampaniaEspecificaViewModel();
        vm.Id = id;
        this.currentCam = vm;
    }

    public clearMenuServiceForCampania(): void {
        const vm = new TCampaniaEspecificaViewModel();
        vm.Id = 0;
        this.currentCam = vm;
    }

    protected get isCamSelected(): boolean {
        if (this.currentCam && this.currentCam.Id) {
            return this.currentCam.Id > 0;
        } else return false;
    }
}
